import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import TidalEmployeeSelect from './atoms/EmployeeSelect/TidalEmployeeSelect'
import { ReferralFormProps } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralForm/UpdateReferralForm'
import { Theme } from '@mui/material/styles'

export function TidalEmployeeContent(props: ReferralFormProps) {
  return (
    <Box>
      <Typography
        variant="body1"
        sx={{
          color: (theme: Theme) => theme.palette.text.secondary,
        }}
      >
        Add Employee
      </Typography>
      <Typography variant="body2" pb={'12px'}>
        Will not transfer upon Location Match / Creation
      </Typography>
      <TidalEmployeeSelect {...props} />
    </Box>
  )
}
